import { allHtmlParsers } from '@utils/ast';
import { bindUnvalidatableInputMaker } from '../util.make-unvalidatable-input.js';

/**
 * NB: Audio inputs are purely used as a way to add audio-files to a task. They
 * are NOT validatable and shouldn't be considered in validation.
 */

const makeUnvalidatableInput = bindUnvalidatableInputMaker();
const inlineAudioInput = makeUnvalidatableInput({
  parsers: {
    inlineaudio: (node, context) => {
      const inputContext = context.extra;
      const index = Array.from(node.parentElement?.children ?? []).filter(child => !Object.keys(allHtmlParsers).includes(child.tagName.toLowerCase())).indexOf(node);
      const id = node.getAttribute("src");
      if (!id) {
        return null;
      }
      const audios = inputContext?.media?.filter(it => it.type === "Audio");
      const match = audios?.find(it => it.type === "Audio" && it.id === id || it.src === id);
      if (!match?.src) {
        return null;
      }
      return {
        id: `${inputContext?.taskId ? `${inputContext.taskId}-` : ""}${index}`,
        nodeType: "inline-audio",
        src: match.src
      };
    }
  }
});

export { inlineAudioInput };
//# sourceMappingURL=input.inline-audio.js.map
